import { SMSSignatureService } from '@weave/schema-gen-ts/dist/schemas/sms/signature/v1/signature_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSignatureV1Service = bindHTTP(SMSSignatureService);
export const serviceName = 'signature-v1' as const;
